/* The banner owns choices; Shopify owns the permission state. */
(function () {
  'use strict';
  var lastState;
  window.mosaikasaPrivacyReady = new Promise(function (resolve, reject) {
    function publish() {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      function allowed(name) {
        return !!(api && typeof api[name] === 'function' && api[name]() === true);
      }
      var analytics = allowed('analyticsProcessingAllowed');
      var marketing = allowed('marketingAllowed');
      var ads = marketing && allowed('saleOfDataAllowed');
      var state = [analytics, marketing, ads].join(',');
      if (state === lastState) return;
      lastState = state;
      window.gtag('consent', 'update', {
        analytics_storage: analytics ? 'granted' : 'denied',
        ad_storage: marketing ? 'granted' : 'denied',
        ad_user_data: ads ? 'granted' : 'denied',
        ad_personalization: ads ? 'granted' : 'denied'
      });
      window.dataLayer.push({
        event: 'mosaikasa_consent_ready',
        mosaikasa_analytics_allowed: analytics,
        mosaikasa_ads_allowed: ads,
        storefront_host: window.location.hostname.toLowerCase()
      });
    }
    document.addEventListener('visitorConsentCollected', publish);
    function ready(error) {
      if (error || !window.Shopify.customerPrivacy) {
        reject(error || new Error('Shopify privacy API unavailable'));
        return;
      }
      publish();
      resolve(window.Shopify.customerPrivacy);
    }
    if (window.Shopify && window.Shopify.customerPrivacy) ready();
    else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], ready);
    } else reject(new Error('Shopify privacy API unavailable'));
  });
  // Never fall back to the old cookie-consent=closed cookie or granted consent.
  window.mosaikasaPrivacyReady.catch(function () {});
})();
